import { FC } from 'react';
import { Box, BoxProps, Img } from '@chakra-ui/react';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ImageStyleFragment, Maybe } from '../../generated/types';
import Link from 'next/link';
// CSS
import 'swiper/css';
import 'swiper/css/pagination';
import { ImageWithDerivative } from '../../types/global';

type ImageSliderProps = BoxProps & {
  images: ImageWithDerivative[];
  url?: string;
  hideCopyright?: boolean;
};

const InnerImage: FC<{
  image: ImageWithDerivative;
  url?: string;
  hideCopyright?: boolean;
}> = ({ image, url, hideCopyright }) => {
  const Image = (
    <Box pos="relative">
      <Img
        width="100%"
        src={image.imageStyle.url}
        htmlWidth={image.imageStyle.width}
        htmlHeight={image.imageStyle.height}
        alt={image.alt || ''}
        loading="lazy"
      />
      {!hideCopyright && image.copyright && (
        <Box
          pos="absolute"
          left={0}
          bottom={0}
          bg="rgba(0,0,0, .4)"
          color="white"
          p={1}
          fontSize="xxs"
        >
          {image.copyright}
        </Box>
      )}
    </Box>
  );

  return url ? (
    <Link href={url}>
      <a>{Image}</a>
    </Link>
  ) : (
    Image
  );
};

export const ImageSlider: FC<ImageSliderProps> = ({
  images,
  url,
  hideCopyright,
  ...props
}) => {
  if (images.length === 1) {
    const image = images[0];

    return (
      <Box {...props}>
        <InnerImage hideCopyright={hideCopyright} image={image} url={url} />
      </Box>
    );
  }

  return (
    <Box
      {...props}
      __css={{
        '.swiper-pagination-bullet': {
          border: '1px solid #fff',
          width: '12px',
          height: '12px',
          bg: 'rgba(0,0,0, .4)',
          opacity: 1,
        },
        '.swiper-pagination-bullet-active': {
          bg: '#fff',
        },
      }}
    >
      <Swiper
        modules={[Pagination]}
        pagination={{
          clickable: true,
        }}
        slidesPerView={1}
      >
        {images.map((image, i) => (
          <SwiperSlide key={i}>
            <InnerImage hideCopyright={hideCopyright} image={image} url={url} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};
